// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1344":"2029744d","2765":"70fb79eb","2880":"2029744d","5202":"ffab1e78","5694":"1c2c17b4","6645":"d3236dbb","7484":"232b7842"}[chunkId] + ".chunk.css";
};